import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LogoService {
  private logoSubject = new BehaviorSubject<string>('assets/images/logos/Whiterobe-final-logo.svg'); // default
  logo$ = this.logoSubject.asObservable();
  updateLogo(url: string | null | undefined) {
    const finalUrl = url && url.trim() !== ''
      ? url
      : 'assets/images/logos/Whiterobe-final-logo.svg';
    this.logoSubject.next(finalUrl);
  }
  /* updateLogo(logoUrl: string) {
    this.logoSubject.next(logoUrl);
  } */
}
